import { AsyncPipe, formatDate } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, ViewRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActiveCartService, MultiCartService } from '@spartacus/cart/base/core';
import { Cart } from '@spartacus/cart/base/root';
import { AuthService, GlobalMessageService, GlobalMessageType, RoutingService, UserIdService } from '@spartacus/core';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription, combineLatest, iif, of, timer } from 'rxjs';
import { concatMap, filter, map, skip, switchMap, take, tap } from 'rxjs/operators';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { GoogleTagManagerService } from 'src/app/service/googletagmanager/google-tag-manager.service';
import { CustomTranslationService } from 'src/app/service/language/custom-translation.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-saved-carts-list-restore-modal',
  templateUrl: './saved-carts-list-restore-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [AsyncPipe],
  standalone: false,
})
export class SavedCartsListRestoreModalComponent implements OnInit, OnDestroy {
  cartId: string;
  cartName: string;
  cartTotalItems: string;
  reorder: boolean;
  erpOrderType: string;
  isSavedCartDetails: boolean;
  activeCartId: string;
  activeCartCount: number;
  restoreCartModalForm: FormGroup;
  cartNameInput: FormControl;
  confirmSave: FormControl;
  today: number = Date.now();
  restoreInprogress = false;
  dateFormatted: string;
  savedCartDetailsGtmDataLayer: any;
  reorderDetailsGtmDataLayer: any;
  errorMessages: Array<any> = [];
  activeCartIdSubscription$: Subscription;
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  windowClass: string;

  isMobile = false;
  csTabletWidth = this.breakpointService.getSize(BREAKPOINT.sm);

  customTranslationSubscription: Subscription;
  isCustomTranslationsEnabled: boolean;
  activeCountry = this.pipeAsync.transform(this.activeCountry$);
  activeLanguage = this.pipeAsync.transform(this.activeLanguage$);
  uniqueErrors: any = {};

  constructor(
    protected modalService: StandardModalService,
    private cartService: ActiveCartService,
    private saveCartService: CartExtendService,
    private componentService: ComponentService,
    private messageService: GlobalMessageService,
    private routing: RoutingService,
    private cdr: ChangeDetectorRef,
    private gtmService: GoogleTagManagerService,
    private countryService: ShimanoCountryService,
    private languageService: ShimanoLanguageService,
    private customTranslationService: CustomTranslationService,
    private pipeAsync: AsyncPipe,
    private multiCartService: MultiCartService,
    private authService: AuthService,
    private breakpointService: BreakpointService,
    private userIdService: UserIdService,
    public deviceDetectorService: DeviceDetectorService,
    private storageService: StorageService
  ) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res) => {
        // saved cart page
        this.cartId = res.cartId;
        this.cartName = res.cartName;
        this.cartTotalItems = res.cartTotalItems;
        this.dateFormatted = res.dateFormatted;
        this.reorder = res.reorder;

        // saved cart details page
        this.isSavedCartDetails = res.isSavedCartDetails;
        this.savedCartDetailsGtmDataLayer = res.savedCartDetailsGtmDataLayer;

        // ReOrder
        this.erpOrderType = res.erpOrderType;
        this.reorderDetailsGtmDataLayer = res.reorderDetailsGtmDataLayer;
        this.windowClass = res.windowClass;
      });
  }

  ngOnInit() {
    if (this.windowClass !== undefined) {
      document.querySelector('.saved-carts-list-modal-container').classList.add(this.windowClass);
    }

    this.isMobile = window.innerWidth < this.csTabletWidth;

    this.createFormControls();
    this.createForm();
    this.setRestoreCartModalFormValidation();

    this.getActiveCartId();

    this.cartService
      .getActive()
      .pipe(take(1))
      .subscribe((data) => {
        this.activeCartCount = data.totalItems;
        if (this.activeCartCount < 1) {
          this.restoreCartModalForm.removeControl('cartNameInput');
        }
      });

    this.customTranslationSubscription = combineLatest([this.activeCountry$, this.activeLanguage$])
      .pipe(
        switchMap(([activeCountry, activeLanguage]) =>
          this.customTranslationService.isCustomTranslationsEnabled$(activeCountry, activeLanguage, [
            'cart.reorder.noEntriesAddedToCart',
            'cart.saveAndRestoreCartSuccessMessage',
            'cart.savedCartsModal.genericError',
          ])
        ),
        tap((isCustomTranslationsEnabled) => {
          this.isCustomTranslationsEnabled = isCustomTranslationsEnabled;
        })
      )
      .subscribe();
  }

  onRestoreSavedCart(cartTotalItems: any) {
    if (this.restoreCartModalForm.valid && !this.restoreInprogress) {
      if ((this.restoreInprogress = true && !this.isMobile)) {
        const loadingIndicator = document.getElementsByClassName('primary-btn')[0] as HTMLElement;
        loadingIndicator.style.padding = '13px 0';
      }
      const cartNameInput = this.restoreCartModalForm.value.cartNameInput;
      const cartDescInput = 'Cart_' + this.activeCartId;
      this.componentService.setIsSavingCart(false);
      this.storageService.setSessionStorageItem('isRestoringCart', 'true');
      if (this.reorder) {
        if (this.activeCartCount > 0) {
          this.reorderCart(this.cartId, cartNameInput, cartDescInput);
        } else {
          this.confirmSave.setValue(false);
          this.reorderCart(this.cartId);
        }
      } else {
        if (this.activeCartCount > 0) {
          if (cartTotalItems > 0) {
            this.restoreSavedCart(this.cartId, cartNameInput, cartDescInput);
          } else {
            this.messageService.add({ key: 'cart.noActiveCart' }, GlobalMessageType.MSG_TYPE_ERROR);
            setTimeout(() => {
              this.closeModal();
              return;
            }, 1000);
          }
        } else {
          this.confirmSave.setValue(false);
          if (cartTotalItems > 0) {
            this.restoreSavedCart(this.cartId);
          } else {
            this.messageService.add({ key: 'cart.noActiveCart' }, GlobalMessageType.MSG_TYPE_ERROR);
            setTimeout(() => {
              this.closeModal();
              return;
            }, 1000);
          }
        }
      }
    }
  }

  reorderCart(cartId: string, name?: string, description?: string) {
    this.restoreInprogress = true;
    let newCartId: string;

    iif(
      () => this.confirmSave.value,
      this.saveCartService.saveCart({ name, description }, this.activeCartId),
      this.saveCartService.deleteCart(this.activeCartId ?? this.cartId)
    )
      .pipe(
        take(1),
        switchMap(() => this.saveCartService.reorderService(cartId, this.erpOrderType)),
        map((response) => {
          newCartId = response.code;
          return response;
        }),
        switchMap(() =>
          timer(0, 2000).pipe(
            concatMap(() => this.saveCartService.getCartProcessStatus(newCartId)),
            filter((data) => data.status === 'COMPLETED'),
            take(1)
          )
        )
      )
      .subscribe({
        next: () => {
          this.preProcessCartRestore(newCartId);
          this.checkRestoredCart();
          //reorder
          this.gtmService.pushTag({
            ecommerce: null,
            search_term: '',
            results_page: '',
            affiliation: '',
            content_type: '',
            content_id: '',
            content_name: '',
          });
          this.gtmService.pushTag(this.reorderDetailsGtmDataLayer);
        },
        error: (errResponse) => {
          if (!this.isCartModificationPaymentError(errResponse)) {
            this.preProcessCartRestore(newCartId);
            this.errorMessages = errResponse.error.errors;
            this.checkRestoredCart(true);
            if (!(this.cdr as ViewRef).destroyed) {
              this.cdr.detectChanges();
            }
          }
        },
      });
  }

  restoreSavedCart(cartId: string, name?: string, description?: string) {
    this.restoreInprogress = true;
    let cloneCartId: string;

    iif(
      () => this.confirmSave.value,
      this.saveCartService.saveCart({ name, description }, this.activeCartId),
      this.saveCartService.deleteCart(this.activeCartId ?? this.cartId)
    )
      .pipe(
        take(1),
        switchMap(() => this.saveCartService.restoreSavedCart(cartId)),
        map((response) => {
          cloneCartId = response.savedCartData.code;
          return response;
        }),
        switchMap(() =>
          timer(0, 2000).pipe(
            concatMap(() => this.saveCartService.getCartProcessStatus(cloneCartId)),
            filter((data) => data.status === 'COMPLETED'),
            take(1)
          )
        )
      )
      .subscribe({
        next: () => {
          this.preProcessCartRestore(cloneCartId);
          this.showGlobalMessage(
            this.confirmSave.value
              ? this.setCustomTranslation(
                  'cart.saveAndRestoreCartSuccessMessage',
                  this.activeCountry,
                  this.activeLanguage
                )
              : 'cart.restoreCartSuccessMessage',
            this.cartName,
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );
          if (this.isSavedCartDetails) {
            this.routing.goByUrl('/cart');
            this.gtmService.pushTag({
              ecommerce: null,
              search_term: '',
              results_page: '',
              affiliation: '',
              content_type: '',
              content_id: '',
              content_name: '',
            });
            this.gtmService.pushTag(this.savedCartDetailsGtmDataLayer);
          }
        },
        error: (errResponse) => {
          if (!this.isCartModificationPaymentError(errResponse)) {
            this.preProcessCartRestore(cloneCartId);
            this.checkRestoredCart(true);
            if (!(this.cdr as ViewRef).destroyed) {
              this.cdr.detectChanges();
            }
            if (this.isSavedCartDetails) {
              this.routing.goByUrl('/cart');
            }
          }
        },
      });
  }

  preProcessCartRestore(cartId: string) {
    this.saveCartService.loadCurrentToActiveCart(cartId);
    this.closeModal();
    this.componentService.setSavedCartsListRefresh(true);
    this.restoreInprogress = false;
    if (this.reorder) {
      this.storageService.removeSessionStorageItem('isRestoringCart');
    }
  }

  checkRestoredCart(onError = false) {
    const sub = this.cartService
      .getActive()
      .pipe(skip(1))
      .subscribe((activeCart) => {
        let showError = true;
        if (activeCart.totalItems === 0 && onError) {
          if (this.reorder) {
            showError = false;
            this.messageService.add(
              {
                key: this.setCustomTranslation(
                  'cart.reorder.noEntriesAddedToCart',
                  this.activeCountry,
                  this.activeLanguage
                ),
              },
              GlobalMessageType.MSG_TYPE_ERROR
            );
            this.routing.goByUrl('/cart');
          } else {
            if (this.storageService.getSessionStorageItem('isSaveCartPage') === 'true') {
              showError = false;
              this.messageService.add(
                { key: 'cart.savedCartsModal.noEntriesAddedToCart' },
                GlobalMessageType.MSG_TYPE_ERROR
              );
            }
          }
        } else {
          if (this.cartName) {
            this.showGlobalMessage(
              this.confirmSave.value
                ? this.setCustomTranslation(
                    'cart.saveAndRestoreCartSuccessMessage',
                    this.activeCountry,
                    this.activeLanguage
                  )
                : 'cart.restoreCartSuccessMessage',
              this.cartName,
              GlobalMessageType.MSG_TYPE_CONFIRMATION
            );
            if (!this.reorder) {
              this.showGlobalMessage('cart.restoreCartFailedMessage', this.cartName, GlobalMessageType.MSG_TYPE_ERROR);
            }
          }
        }
        if (showError) {
          this.errorMessages.forEach((error) => {
            if (!this.uniqueErrors[error.message]) {
              this.uniqueErrors[error.message] = {
                message: error.message,
                subjects: {
                  subject: [error.subject],
                },
              };
            } else {
              this.uniqueErrors[error.message].subjects.subject.push(error.subject);
            }
          });
          const output = Object.values(this.uniqueErrors);
          if (this.errorMessages.length <= 10) {
            output.forEach((res: any) => {
              if (res.message === 'product.not.found') {
                res.subjects.subject.forEach((sub: any) => {
                  this.messageService.add(
                    { key: 'cart.savedCartsModal.productNotFound', params: { code: sub } },
                    GlobalMessageType.MSG_TYPE_ERROR
                  );
                });
              } else {
                this.messageService.add(res.message, GlobalMessageType.MSG_TYPE_ERROR);
              }
            });
          } else {
            this.messageService.add(
              {
                key: this.setCustomTranslation(
                  'cart.savedCartsModal.genericError',
                  this.activeCountry,
                  this.activeLanguage
                ),
              },
              GlobalMessageType.MSG_TYPE_ERROR
            );
          }
        }
        this.cartName = '';
        sub.unsubscribe();
      });
  }

  createFormControls() {
    const formattedToday = formatDate(this.today, this.dateFormatted, 'en-US');
    const defaultCartNameInput = 'Cart_' + formattedToday;
    this.cartNameInput = new FormControl(defaultCartNameInput, Validators.required);
    this.confirmSave = new FormControl(true);
  }

  createForm() {
    this.restoreCartModalForm = new FormGroup({
      cartNameInput: this.cartNameInput,
      confirmSave: this.confirmSave,
    });
  }

  setRestoreCartModalFormValidation() {
    const cartNameInputControl = this.restoreCartModalForm.get('cartNameInput');
    this.restoreCartModalForm.get('confirmSave').valueChanges.subscribe((confirmSave) => {
      if (confirmSave) {
        cartNameInputControl.setValidators([Validators.required]);
      } else {
        cartNameInputControl.setValidators(null);
      }
      cartNameInputControl.updateValueAndValidity();
    });
  }

  getActiveCartId() {
    this.activeCartIdSubscription$ = this.saveCartService
      .getActiveCartId()
      .pipe(
        take(1),
        switchMap((activeCartId) => {
          let id = activeCartId;
          if (!id) {
            return this.multiCartService.createCart({
              userId: this.userCurrent,
              extraData: {
                active: true,
              },
            });
          } else {
            this.activeCartId = id;
            return of(null);
          }
        }),
        filter(Boolean),
        tap((cart: Cart) => {
          this.cartId = cart.code;
        })
      )
      .subscribe();
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  private showGlobalMessage(text: string, param: string, messageType: GlobalMessageType) {
    this.messageService.add({ key: text, params: { cartName: param } }, messageType);
    const element: HTMLElement = document.getElementsByClassName('BottomHeaderSlot')[0] as HTMLElement;
    element.scrollIntoView();
  }

  get activeCountry$(): Observable<string> {
    return this.countryService.getActive();
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  setCustomTranslation(translationKey: string, activeCountry: string, activeLanguage: string): string {
    return this.isCustomTranslationsEnabled
      ? translationKey + '_' + [activeCountry, activeLanguage].join('-')
      : translationKey;
  }

  customizeModalButtons(activeLanguage: any, reorderModal: boolean): boolean {
    return activeLanguage === 'nl' && !reorderModal;
  }

  checkIsMobileAndNoActiveCart(): boolean {
    return this.isMobile && !this.activeCartCount ? false : true;
  }

  isCartModificationPaymentError(resp: HttpErrorResponse): boolean {
    return resp.error?.errors?.some((err: any) => err.type === 'ShimanoCartModificationPaymentError');
  }

  closeModal(info?: any) {
    this.modalService.closeDialog(info);
  }

  ngOnDestroy() {
    if (this.customTranslationSubscription) {
      this.customTranslationSubscription.unsubscribe();
    }
    if (this.activeCartIdSubscription$) {
      this.activeCartIdSubscription$.unsubscribe();
    }
  }
}
